import config from '../../config';
import { createAction } from 'redux-actions';
import {
  restoreDishesLocalStorage,
  storeDishesLocalStorage,
  clearDishesLocalStorage,
  getFullscreenAdShow,
  setUserOrderedDishListMustOrderProps,
} from '../../helper/dish-helper';
import { getUrlParam, interValSetting, getRecommendDish, getRunEnv } from '../../helper/common-helper';
import { clearTableInfoInSessionStorage, getTableInfoInSessionStorage, setTableInfoInSessionStorage } from '../../helper/order-dinner-cart-helper';
import { get } from '../../helper/http-request-helper';
import { getServiceStatus } from '../common-action/common-action';
import pageHelper from '../../helper/page-helper';
import { formatMessage } from '../../intl/helper';
import errorMessages from '../../intl/messages/error-message';
import globalMessages from '../../intl/messages/global';
import { MemberPrivTypes } from '../../helper/const';
import fetchHelper from '../../helper/fetch-helper';

const setMenuData = createAction('SET_MENU_DATA', menuData => menuData);
const setShopInfo = createAction('SET_SHOP_INFO', shopInfo => shopInfo);
const _orderDish = createAction('ORDER_DISH', (dishData, action) => [dishData, action]);
const changeDish = createAction('CHANGE_DISH', (dishData, action) => [dishData, action]);
const _removeAllOrders = createAction('REMOVE_ALL_ORDERS', orders => orders);
const _clearSaveOrder = createAction('CLEAR_SAVE_ORDER', orders => orders);
const _reinstateUndefined = createAction('REINSTATE_UNDEFINED', orders => orders);
const setDiscountToOrder = createAction('SET_DISCOUNT_TO_ORDER', discount => discount);
const setNormalDiscount = createAction('SET_NORMAL_DISCOUNT', discount => discount);
const setErrorMsg = (exports.setErrorMsg = createAction('SET_ERROR_MSG', error => error));
const setLoadMsg = createAction('SET_LOAD_MSG', loadinfo => loadinfo);
const setCouponSuccessInfo = createAction('SET_COUPON_SUCCESS_INFO', couponSuccessInfo => couponSuccessInfo);
const setCouponSuccess = createAction('SET_COUPON_SUCCESS', couponSuccess => couponSuccess);
const setCallMsg = createAction('SET_CALL_MSG', callInfo => callInfo);
const setCancelCanMsg = createAction('SET_CANCEL_CALL_MSG', callInfo => callInfo);
const setCanCall = createAction('SET_CAN_CALL', callAble => callAble);
const setTableAreaInfo = createAction('SET_TABLE_AREA_INFO', tableAreaInfo => tableAreaInfo);
const setUserInfo = createAction('SET_USER_INFO', info => info);
const setAuthInfo = createAction('SET_AUTH_INFO', info => info);
const setToastProps = (exports.setToastProps = createAction('SET_TOAST_PROPS', props => props));
const setSoldDishList = createAction('SET_SOLD_DISH_LIST', soldTopDishList => soldTopDishList);
const setDataInitOver = createAction('SET_DATA_INIT_OVER', isOver => isOver);
const setGuidStatus = createAction('SET_GUID_STATUS', status => status);
const setMustOrderDishList = createAction('SET_MUST_ORDER_DISH_LIST', list => list);
// exports.setCouponStatus = createAction('SET_COUPON_STATUS', couponStatus => couponStatus);

// 设置店铺的营业状态 - 外卖和堂食点餐
const setShopOrderStatus = createAction('SET_SHOP_ORDER_STATUS', shopOrderStatus => shopOrderStatus);
const setPageLoadedStatus = (exports.setPageLoadedStatus = createAction('SET_PAGE_LOADED_STATUS', pageLoadedStatus => pageLoadedStatus));

const YDtime = getUrlParam('presetTime');

const shopId = getUrlParam('shopId');
const orderType = getUrlParam('type');
let dishListUrl = `${config.orderallDishListAPI}?shopId=${shopId}`;
if (YDtime) {
  dishListUrl = `${config.orderAllYDListAPI}?shopId=${shopId}&presetTime=${YDtime}`;
}
const runEnv = getRunEnv();
const shopInfoUrl = `${config.orderallShopInfoAPI}?shopId=${shopId}&runEnv=${runEnv}`;

const errorLocation = (errorCode, errorMsg) => {
  clearTableInfoInSessionStorage();
  sessionStorage.errorMsg = errorMsg || formatMessage(errorMessages.unknown);
  location.href = `${config.exceptionLinkURL}?shopId=${shopId}&linkType=1&diningForm=0`;
};

const getCoupontoGuid = (exports.getCoupontoGuid = (info, resolve) => (dispatch, getState) => {
  dispatch(setGuidStatus(info));

  if (resolve) {
    resolve();
  }
});

const saveTableParam = (exports.saveTableParam = tableInfo => (dispatch, getState) => {
  setTableInfoInSessionStorage(shopId, tableInfo);
});

exports.dataInitIsOver = is => dispatch => {
  dispatch(setDataInitOver(is));
};

// 如果session中有tableId的话将table信息读取出来展示在页面上
exports.fetchTableInfo = tableInfo => dispatch => {
  const { tableId, tableKey } = tableInfo || {};

  let urlString = '';

  if (tableId || tableKey) {
    const tableStr = tableId ? 'tableId' : 'tableKey';
    urlString = `&${tableStr}=${tableId || tableKey}`;
  }

  return fetchHelper
    .get(`${config.getTableInfoAPI}?${urlString}`, { shopId })
    .then((table = {}) => {
      dispatch(setTableAreaInfo(table));
    })
    .catch((err = {}) => {
      errorLocation(err.code, err.msg);
    });
};

const jumpToDishMenu4DinnerChoosePeopleURL = (serviceStatus = {}) => (dispatch, getState) => {
  const choosePeopleCountFlag = getState().dishMenuReducer.shopInfo.choosePeopleCountFlag;
  const peopleCount = serviceStatus.peopleCount;
  const tableWay = serviceStatus.tableWay;
  const tableId = serviceStatus.tableId;
  const tableKey = serviceStatus.tableKey;
  const orderId = serviceStatus.orderId;
  const isSync = !!(tableId || tableKey || orderId); // 是否为协同点餐
  // 新增如果需要选择人数 则自动跳转到选择人数页面 (一桌一单)
  /* 暂时屏蔽 */
  if (
    tableWay === 'oneTableOneBill' && // 一桌一单
    isSync && // 协同点餐
    choosePeopleCountFlag && // 配置打开
    (tableId || tableKey) && // 扫码进入
    !orderId && // 没有订单
    !peopleCount // 没有选择人数
  ) {
    let href = `${config.dishMenu4DinnerChoosePeopleURL}?shopId=${shopId}&returnUrl=${encodeURIComponent(location.href)}`;
    if (tableId) {
      href = `${href}&tableId=${tableId}`;
    } else if (tableKey) {
      href = `${href}&tableKey=${tableKey}`;
    }
    location.href = href;
    return true;
  }
  return false;
};

// 获取serviceStatus
const fetchServiceStatusNoTable = (exports.fetchServiceStatusNoTable = tableInfo => (dispatch, getState) => {
  const { tableId, tableKey, orderId } = tableInfo || {};

  return getServiceStatus({ tableId, tableKey, orderId })(dispatch).then(serviceStatus => {
    if (!serviceStatus) {
      return '';
    }

    if (serviceStatus.errCode) {
      const { errCode, errMsg } = serviceStatus;
      errorLocation(errCode, errMsg);
      return '';
    }

    if (serviceStatus.peopleCount) {
      // 保存已经选择的人数
      sessionStorage.orderDinnerCartPersonCount = serviceStatus.peopleCount.toString();
    }

    const ifJumpToDishMenu = jumpToDishMenu4DinnerChoosePeopleURL(serviceStatus)(dispatch, getState);
    return { serviceStatus, ifJumpToDishMenu };
  });
});

// 保存url的table信息，用于扫码点餐url自带tableId/tableKey，此接口进页面必调用
exports.saveTableInfoFromUrl = (tableInfo = {}) => (dispatch, getStates) => {
  if (tableInfo.tableId || tableInfo.tableKey || tableInfo.orderId || tableInfo.ownerId) {
    saveTableParam(tableInfo)(dispatch, getStates);
  }

  // 获取sessionStorage的tableInfo,所有tableInfo都从session里面取
  const tableInfoFromSession = getTableInfoInSessionStorage(shopId);

  // 获取serviceStatus
  return fetchServiceStatusNoTable(tableInfoFromSession)(dispatch, getStates);
};

exports.activeDishType = createAction('ACTIVE_DISH_TYPE', (evt, dishTypeId, dishTypeIdIndex) => {
  window.__activeTypeByTap__ = evt && /dish-type-item/.test(evt.target.className);
  return { dishTypeId, dishTypeIdIndex };
});

exports.fetchShopInfo = (tableId, tableKey) => (dispatch, getState) => {
  dispatch(setPageLoadedStatus(false));
  return fetchHelper
    .get(shopInfoUrl)
    .then((data = {}) => {
      data.showFullscreenAd = getFullscreenAdShow(data);
      dispatch(setShopInfo(data));
      const { bizStatus } = data || {};

      // 在没有优惠券的情况下 主动弹出新手引导
      if (getUrlParam('getCoupon')) {
        dispatch(getCoupontoGuid(true));
      } else if (data.isOldMarketing && (!data.takeCouponVO || !data.takeCouponVO.coupId)) {
        // 老逻辑
        dispatch(getCoupontoGuid(true));
      } else if (!data.isOldMarketing && (!data.takeCouponVOS || data.takeCouponVOS.length === 0)) {
        // 新逻辑
        dispatch(getCoupontoGuid(true));
      }

      if (bizStatus) {
        const isAcceptOrder = bizStatus.slice(0, 1) === '1' && getUrlParam('type') === 'TS';
        dispatch(setShopOrderStatus(isAcceptOrder));
      }
    })
    .catch((err = {}) => {});
};

exports.fetchMenuData = () => dispatch => {
  return fetchHelper
        .get(dishListUrl)
        .then((data = {}) => {
          sessionStorage.setItem('dishTypeList', JSON.stringify(data.dishTypeList));
          const newData = restoreDishesLocalStorage(data);
          dispatch(setMenuData(newData));
          // if (callBack) {
          //   callBack();
          // }
          // dispatch(setSoldDishList(menuData.data.soldTopInfos));
      });
};

exports.fetchSoldDishList = () => dispatch => {
  // 点餐页推荐菜品 rqo = request recommendDishList ordering_page
  const rqo = getRecommendDish((orderType || '').toLowerCase(), 'ordering_page')
    .then(recommendDishList => dispatch(setSoldDishList({ dishMenuRecommendList: recommendDishList })))
    .catch(errMsg => dispatch(setErrorMsg({ text: errMsg })));

  // 商品详情页 rqd = request recommendDishList dish_detail_page
  const rqd = getRecommendDish((orderType || '').toLowerCase(), 'dish_detail_page')
    .then(recommendDishList => dispatch(setSoldDishList({ dishDetailRecommendList: recommendDishList })))
    .catch(errMsg => dispatch(setErrorMsg({ text: errMsg })));

  // 这样写是为了两个请求并行
  return rqo.then(() => rqd);
};

exports.orderDish = (dishData, action, isStorageInLocal) => (dispatch, getStates) => {
  dispatch(_orderDish(dishData, action));
  dispatch(changeDish(dishData, action));
  const dishTypeList = JSON.parse(sessionStorage.dishTypeList || '[]');
  const dishTypeObj = {};
  dishTypeList.forEach((item = {}) => {
    dishTypeObj[item.id] = item.name;
  });
  const fadeDishes = Array.prototype.slice.call(getStates().dishMenuReducer.dishesDataDuplicate);
  const getFadeDishes = [];
  fadeDishes.forEach((item = {}) => {
    getFadeDishes.push(
      Object.assign({}, item, {
        dishTypeName: dishTypeObj[item.dishTypeId] || formatMessage(globalMessages.defaultSort),
      })
    );
  });
  if (isStorageInLocal !== false) {
    storeDishesLocalStorage(getFadeDishes, getStates().dishMenuReducer.shopInfo);
  }
};

exports.removeAllOrders = orders => dispatch => {
  dispatch(_removeAllOrders(orders));
  dispatch(_clearSaveOrder(orders));
  clearDishesLocalStorage();
};

exports.reinstateUndefined = orders => dispatch => {
  dispatch(_reinstateUndefined(orders));
};

exports.fetchOrderDiscountInfo = (discountRule = {}) => (dispatch, getState) => {
  // 平头哥 屏蔽会员优惠
  const { dishMenuZcReducer: { shopMinConsume = {} } } = getState();
  if (shopMinConsume && shopMinConsume.state === 1) {
    dispatch(setDiscountToOrder({ dishList: [] }));
    return Promise.resolve();
  }

  return fetchHelper.get(`${config.orderDiscountInfoAPI}`, { shopId }, { enableDefaultResponseResolve: false }).then((response = {}) => {
    const res = response.data || {};
    if (res.code !== '200') {
      if (res.code !== 'NOT_LOGIN') {
        dispatch(setErrorMsg({ text: res.msg }));
      }
    }

    const { dishList = [], isMember = false, type = 1 } = res.data || {};

    if ((dishList && dishList.length) || type === MemberPrivTypes.UNIFIED_DISCOUNT) {
      dispatch(setDiscountToOrder({
        ...res.data,
        ableAddPriceDiscount: discountRule.ableAddPriceDiscount,  // 是否开启会员加价折扣
      }));
    } else {
      dispatch(setDiscountToOrder({ ...discountRule, isMember }));
    }
  });
};

exports.showErrMsgFunc = msg => (dispatch, getState) => dispatch(setErrorMsg({ text: msg }));

exports.clearErrorMsg = () => (dispatch, getState) => dispatch(setErrorMsg({}));

exports.cancelCallMsg = () => (dispatch, getState) => dispatch(setCancelCanMsg(null));

exports.updateCanCall = isCan => (dispatch, getState) => dispatch(setCanCall(isCan));

// 临时注释，以后有用勿删
// const removeBasicSession = (name) => {
//   sessionStorage.removeItem(name);
// };

// call 服务铃
exports.callBell = (timer, contentCode, contentMsg) => (dispatch, getStates) => {
  const orderId = getStates().dishMenuZcReducer.serviceStatus.orderId || '';
  const tableId = getStates().dishMenuZcReducer.serviceStatus.tableId;
  dispatch(setCanCall(true));
  const callServiceAPI =
    `${config.callServiceAPI}`;
  const queries = {
    shopId,
    orderId,
    tableId,
    contentCode,
    contentMsg,
  };

  return fetchHelper.get(`${callServiceAPI}`, queries).then((data = {}) => {
    dispatch(setCanCall(false));
    interValSetting(timer, () => {
      dispatch(setCanCall(true));
    });
    if (data.status.toString() === '1501') {
      // 已经呼叫过服务员了
      dispatch(
        setCallMsg({
          info: data.message,
          callStatus: true,
        })
      );
      return;
    }
    dispatch(
      setCallMsg({
        info: formatMessage(errorMessages.waiterWillCome),
        callStatus: true,
      })
    );
  })
  .catch((err = {}) => {
    dispatch(
      setCallMsg({
        info: err.msg || formatMessage(errorMessages.sendFail),
        callStatus: false,
      })
    );
  });
};

exports.fetchDishMarketInfos = () => dispatch => {
  return fetchHelper.get(`${config.getDishMarketInfosAPI}`, { shopId }).then((marketInfoData = {}) => {
    if (!marketInfoData) {
      return {};
    }

    if (!marketInfoData.discountInfo || !marketInfoData.discountInfo.dishList || !marketInfoData.discountInfo.dishList.length) {
      marketInfoData.discountInfo = {};
    }

    dispatch(setNormalDiscount(marketInfoData));

    return {
      ...marketInfoData.discountInfo,
      ableAddPriceDiscount: marketInfoData.ableAddPriceDiscount,
    };
  })
  .catch((err = {}) => {
    dispatch(setErrorMsg({ text: err.msg }));
  });
};

exports.clearBell = msg => dispatch => {
  dispatch(
    setCallMsg({
      info: msg,
      callStatus: false,
    })
  );
};

exports.getMarketCoupons = (couponId, callBack) => (dispatch, getState) => {
  dispatch(setLoadMsg({ status: true, word: formatMessage(errorMessages.beingInTheVoucher) }));
  // 根据需求判断新老接口
  const { isOldMarketing, ruleId, planId } = getState().dishMenuReducer.shopInfo || {};

  let queries = {
    shopId,
  };
  if (isOldMarketing) queries = { ...queries, couponId };
  else queries = { ...queries, ruleId, planId };

  return fetchHelper.get(`${isOldMarketing ? config.fetchCouponAPI : config.sendCouponsAPI}`, queries, { enableDefaultResponseResolve: false })
  .then((res = {}) => {
    dispatch(setLoadMsg({ status: false, word: '' }));
    const result = res.data || {};

    if (result.code === '200') {
      if (isOldMarketing) { // 老逻辑
        dispatch(setCouponSuccessInfo(result.data.coup));
      } else { // 新逻辑
        dispatch(setCouponSuccess(result.data)); // true 成功  false 失败
      }

      // 领券成功关闭掉领券页面
      if (callBack) {
        callBack();
      }
    } else if (result.code === '60200') {
      dispatch(setErrorMsg({ text: formatMessage(errorMessages.tryAgainForGet) }));
    } else if (result.code === '110000') {
      dispatch(setErrorMsg({ text: result.msg }));
    } else {
      if (result.code === 'NOT_LOGIN') { // 用户未登录
        setTimeout(() => {
          pageHelper.navigateToLoginPage({
            shopId,
            getCoupon: true,
          });
        }, 800);
      }
    }
  });
};


// 判断用户是否登录 仅在一桌一单加菜模式下会用到
exports.fetchUserInfo = memberVO => dispatch => {
  dispatch(setUserInfo(memberVO));
  sessionStorage.setItem('userInfo', JSON.stringify(memberVO));
};

exports.fetchWXAuthInfo = () => dispatch => {
  const authUrl = encodeURIComponent(location.href);

  return fetchHelper.get(`${config.getWXAuthInfoAPI}`, { shopId, reqUrl: authUrl }).then((result = {}) => {
    dispatch(setAuthInfo(result));
    return result;
  }).catch((err = {}) => {
    dispatch(setErrorMsg({ text: `${err.msg}, ${formatMessage(errorMessages.cantCallTableQRCode)}` }));
  });
};

exports.closeInfoWindow = () => dispatch => {
  dispatch(setToastProps(null));
};

// 获取扫桌台码信息
exports.fetchTableIdFromNewVersionQRCode = tableUrl => (dispatch, getState) => {
  return fetchHelper.get(`${config.getTableIdFromQRCodeAPI}`, { shopId, url: tableUrl }).then((res = {}) => {
    const tableInfo = {
      tableId: res.synFlag || '',
    };
    // 扫桌台码，将tableInfo存进session
    saveTableParam(tableInfo)(dispatch, getState);
    location.href = `${config.dishMenu4DinnerURL}?shopId=${shopId}&tableId=${res.synFlag}&type=TS`;
  })
  .catch((err = {}) => {
    dispatch(setErrorMsg({ text: err.msg }));
  });
};

exports.syncShoppingCart = shoppingCartDishData => (dispatch, getState) => {
  const { userInfo = {} } = shoppingCartDishData;
  let { userOrderedDishList } = shoppingCartDishData;
  const { dishMenuZcReducer: { mustOrderDishList, selfChooseDishList } } = getState();
  const action = createAction('SYNC_SHOPPING_CART', data => data);

  // 设置必点菜的属性
  if (mustOrderDishList.length || selfChooseDishList.length) {
    userOrderedDishList = setUserOrderedDishListMustOrderProps(userOrderedDishList, mustOrderDishList.concat(selfChooseDishList));
  }

  dispatch(action(userOrderedDishList));

  const currentUserOrderedResult = (userOrderedDishList || []).filter(item => item.userInfo.userId === userInfo.userId)[0];
  const { dishList = [] } = currentUserOrderedResult || {};
  if (dishList.length) {
    const updateOrderedDishAction = createAction('UPDATE_DISH_ORDER', data => data);
    dispatch(updateOrderedDishAction(dishList));
  }
};

exports.addOrderNotice = notice => dispatch => {
  const action = createAction('ADD_ORDER_NOTICE', data => data);
  dispatch(action(notice));
};

exports.readOrderNotice = readedIndex => dispatch => {
  const action = createAction('READ_ORDER_NOTICE', data => data);
  dispatch(action(readedIndex));
};

exports.syncDishesFromShoppingCart = shoppingCartDishes => dispatch => {
  dispatch(createAction('SYNC_DISHES_FROM_SHOPPINGCART', data => data));
};

exports.fetchMustOrderMenu = () => (dispatch, getState) => {
  const { dishMenuReducer: { shopInfo = {} } } = getState();
  if (!shopInfo.enableOpenDish) {
    return false;
  }

  return fetchHelper.get(`${config.mustOrderDishListAPI}`, { shopId, type: 'TS' })
    .then((res = {}) => {
      dispatch(setMustOrderDishList(res));
    })
    .catch((err = {}) => {
      dispatch(setErrorMsg(err.msg));
    });
};



// WEBPACK FOOTER //
// ./src/action/dish-menu/dish-menu-zc.js